import React from 'react';
import PropTypes from 'prop-types';

import { Body } from '../../typography';
import Spacer from '../../spacer';
import CdeFeedback from './cde-feedback';
import StepsFeeedback from './steps-feedback';
import RadioFeedback from './radio-feedback';
import FluidContainer from '../../layouts/components/fluid-container';

const CheckerFeedback = ({ exercise, answers, correctionStatus }) => {
    return (
        <FluidContainer flexDirection="column" marginLeft="regular" marginRight="regular" paddingBottom="mobile">
            <Body>
                <CdeFeedback exercise={exercise} answers={answers} />

                <StepsFeeedback exercise={exercise} correctionStatus={correctionStatus} steps={answers.steps} />

                <Spacer size="regular" />

                <RadioFeedback exercise={exercise} answers={answers} correctionStatus={correctionStatus} />
            </Body>
        </FluidContainer>
    );
};

CheckerFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
    correctionStatus: PropTypes.object,
};

export default CheckerFeedback;
